import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '../../../core/components/menu/services/menu.service';
import { UserAuthService } from '../../services/user-auth.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from 'ngx-flexible-layout';

@Component({
  selector: 'not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  imports: [
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    FlexLayoutModule
  ]
})
export class NotFoundComponent {

  routerLink: string = '';
  constructor(
    public router: Router,
    public menuService: MenuService,
    public userService: UserAuthService
  ) { }

  public goHome(): void {
    this.userService.goHome();
  }

  public searchForRoute(): void {
    let menuRouterLinkList = this.menuService.getMenuItems()?.map(menuItem => menuItem.routerLink);

    if (this.routerLink) {
      let validRouterLink = menuRouterLinkList?.find(menuItem => menuItem.includes(this.routerLink));
      if (validRouterLink) {
        this.router.navigateByUrl(validRouterLink);
      }
    }
  }
}
